import { InfinityLoader } from "./ui/infinity-loader";
import { errorMessage } from "@/lib/api";

export function FullPageSpinner({ label }: { label?: string } = {}) {
  return (
    <div className="flex h-full min-h-[50vh] w-full items-center justify-center">
      <InfinityLoader size={72} {...(label ? { label } : {})} />
    </div>
  );
}

export function ErrorBlock({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  return (
    <div role="alert" className="hud-corners border border-border-strong px-5 py-6">
      <p className="label-mono">Erro</p>
      <p className="mt-1 text-[13px] text-fg">{errorMessage(error)}</p>
      {onRetry ? (
        <button onClick={onRetry} className="mt-3 text-[13px] font-medium underline underline-offset-4">
          Tentar de novo
        </button>
      ) : null}
    </div>
  );
}

export function PageHeader({
  title,
  description,
  actions,
  eyebrow,
}: {
  title: string;
  description?: string;
  actions?: React.ReactNode;
  /** Kicker em mono acima do título ("● MARKETPLACE"). */
  eyebrow?: string;
}) {
  return (
    <div className="mb-8 flex animate-fade-up flex-wrap items-end justify-between gap-4 border-b border-border/70 pb-6">
      <div>
        {eyebrow ? (
          <p className="eyebrow mb-3">
            <span className="h-1.5 w-1.5 rounded-full bg-fg shadow-[0_0_8px_var(--glow)]" />
            {eyebrow}
          </p>
        ) : null}
        <h1 className="text-gradient text-3xl font-semibold tracking-tight">{title}</h1>
        {description ? <p className="mt-2 max-w-xl text-[14px] text-fg-muted">{description}</p> : null}
      </div>
      {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
    </div>
  );
}
